<template>
  <q-layout view="lHh Lpr lFf">
    <!-- Header -->
    <q-header v-if="!isLoginRoute" class="app-header">
      <q-toolbar class="app-toolbar">
        <q-btn
          flat
          dense
          round
          @click="leftDrawerOpen = !leftDrawerOpen"
          aria-label="Menu"
          icon="menu"
          class="text-white"
        />
        <q-avatar size="40px" class="q-ml-sm">
          <img src="./assets/icon2.png" />
        </q-avatar>
      </q-toolbar>
    </q-header>

    <!-- Sidebar -->
    <q-drawer
      v-if="!isLoginRoute"
      v-model="leftDrawerOpen"
      show-if-above
      :width="260"
      class="sidebar"
    >
      <q-scroll-area class="fit">
        <!-- Brand -->
        <div class="sidebar-brand">
          <q-avatar size="44px" class="brand-avatar">
            <img
              src="https://amzn-s3-goldenkey.s3.us-east-2.amazonaws.com/properties/icon2.png"
            />
          </q-avatar>
          <div class="q-ml-md">
            <div class="brand-name">Golden Key</div>
            <div class="brand-sub">Portal Imobiliário</div>
          </div>
        </div>

        <!-- Profile -->
        <div class="profile-card">
          <q-avatar size="42px" class="profile-avatar">
            <q-icon name="person" size="22px" />
          </q-avatar>
          <div class="q-ml-sm">
            <div class="profile-name">{{ fullname }}</div>
            <q-badge class="role-badge" rounded>
              {{ role === 0 ? "Agente" : role === 1 ? "Admin" : "—" }}
            </q-badge>
          </div>
        </div>

        <!-- Navigation -->
        <q-list class="nav-list">
          <!-- Section: Imóveis -->
          <div class="section-label">Imóveis</div>

          <q-item
            clickable
            v-ripple
            class="nav-item"
            active-class="nav-item--active"
            to="/imovel/adicionar"
            exact
          >
            <q-item-section avatar class="nav-icon-wrap">
              <q-icon name="add_home" size="20px" />
            </q-item-section>
            <q-item-section>
              <q-item-label class="nav-label">Publicar Imóvel</q-item-label>
            </q-item-section>
          </q-item>

          <q-item
            clickable
            v-ripple
            class="nav-item"
            active-class="nav-item--active"
            to="/imoveis"
            exact
          >
            <q-item-section avatar class="nav-icon-wrap">
              <q-icon name="home_work" size="20px" />
            </q-item-section>
            <q-item-section>
              <q-item-label class="nav-label">Meus Imóveis</q-item-label>
            </q-item-section>
          </q-item>

          <!-- Section: Admin -->
          <template v-if="role === 1">
            <div class="section-label q-mt-md">Administração</div>

            <q-item
              clickable
              v-ripple
              class="nav-item"
              active-class="nav-item--active"
              to="/todos-imoveis"
              exact
            >
              <q-item-section avatar class="nav-icon-wrap">
                <q-icon name="domain" size="20px" />
              </q-item-section>
              <q-item-section>
                <q-item-label class="nav-label">Todos os Imóveis</q-item-label>
              </q-item-section>
            </q-item>

            <q-item
              clickable
              v-ripple
              class="nav-item"
              active-class="nav-item--active"
              :to="{ name: 'user-list' }"
              exact
            >
              <q-item-section avatar class="nav-icon-wrap">
                <q-icon name="group" size="20px" />
              </q-item-section>
              <q-item-section>
                <q-item-label class="nav-label">Utilizadores</q-item-label>
              </q-item-section>
            </q-item>

            <q-item
              clickable
              v-ripple
              class="nav-item"
              active-class="nav-item--active"
              to="/carousel"
              exact
            >
              <q-item-section avatar class="nav-icon-wrap">
                <q-icon name="view_carousel" size="20px" />
              </q-item-section>
              <q-item-section>
                <q-item-label class="nav-label">Carousel</q-item-label>
              </q-item-section>
            </q-item>

            <q-item
              clickable
              v-ripple
              class="nav-item"
              active-class="nav-item--active"
              to="/relatorios"
              exact
            >
              <q-item-section avatar class="nav-icon-wrap">
                <q-icon name="bar_chart" size="20px" />
              </q-item-section>
              <q-item-section>
                <q-item-label class="nav-label">Relatórios</q-item-label>
              </q-item-section>
            </q-item>

            <q-item
              clickable
              v-ripple
              class="nav-item"
              active-class="nav-item--active"
              to="/auditoria"
              exact
            >
              <q-item-section avatar class="nav-icon-wrap">
                <q-icon name="manage_search" size="20px" />
              </q-item-section>
              <q-item-section>
                <q-item-label class="nav-label">Auditoria</q-item-label>
              </q-item-section>
            </q-item>
          </template>

          <!-- Section: Conta -->
          <div class="section-label q-mt-md">Conta</div>

          <q-item
            clickable
            v-ripple
            class="nav-item"
            active-class="nav-item--active"
            to="/support"
            exact
          >
            <q-item-section avatar class="nav-icon-wrap">
              <q-icon name="help" class="q-mr-sm" size="20px" />
            </q-item-section>
            <q-item-section>
              <q-item-label class="nav-label">Suporte</q-item-label>
            </q-item-section>
          </q-item>
          <q-item
            clickable
            v-ripple
            class="nav-item"
            active-class="nav-item--active"
            to="/profile"
            exact
          >
            <q-item-section avatar class="nav-icon-wrap">
              <q-icon name="manage_accounts" size="20px" />
            </q-item-section>
            <q-item-section>
              <q-item-label class="nav-label">Perfil</q-item-label>
            </q-item-section>
          </q-item>
        </q-list>

        <!-- Logout -->
        <div class="sidebar-footer">
          <button class="logout-btn" @click="handleLogout">
            <q-icon name="logout" size="18px" class="q-mr-sm" />
            Terminar Sessão
          </button>
        </div>
      </q-scroll-area>
    </q-drawer>

    <q-page-container>
      <router-view />
    </q-page-container>
  </q-layout>
</template>

<script>
import { ref, computed, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import store from "./vuex/store";

export default {
  name: "LayoutDefault",

  setup() {
    const route = useRoute();
    const router = useRouter();
    const leftDrawerOpen = ref(true);
    const selectedMenu = ref("");

    const isLoginRoute = computed(() => {
      return (
        route.path === "/" ||
        route.path === "/login" ||
        route.path === "/auto-register" ||
        route.path.startsWith("/activate-user") ||
        route.path === "/reset-password" ||
        route.path.startsWith("/reset/")
      );
    });

    onMounted(() => {
      if (sessionStorage.getItem("token")) {
        store.dispatch("auth/getMe").catch(() => router.push("/"));
      }
    });

    const handleLogout = async () => {
      try {
        await store.dispatch("auth/logout");
      } finally {
        sessionStorage.removeItem("token");
        router.push("/");
      }
    };

    const fullname = computed(
      () => store.state.auth.user?.name || "Utilizador",
    );
    const role = computed(() => store.state.auth.user?.role);

    return {
      leftDrawerOpen,
      selectedMenu,
      isLoginRoute,
      fullname,
      role,
      handleLogout,
    };
  },
};
</script>

<style scoped>
/* ── Header ──────────────────────────────────────────── */
.app-header {
  background: #0d1b2a;
  border-bottom: 1px solid rgba(212, 175, 55, 0.15);
  box-shadow: none;
}
.app-toolbar {
  min-height: 56px;
}

/* ── Sidebar shell ───────────────────────────────────── */
.sidebar {
  background: #0d1b2a !important;
  border-right: 1px solid rgba(255, 255, 255, 0.06) !important;
}

/* ── Brand ───────────────────────────────────────────── */
.sidebar-brand {
  display: flex;
  align-items: center;
  padding: 24px 20px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}
.brand-avatar {
  border: 2px solid rgba(212, 175, 55, 0.4);
  border-radius: 12px;
  overflow: hidden;
}
.brand-name {
  font-size: 17px;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: 0.3px;
}
.brand-sub {
  font-size: 11px;
  color: rgba(212, 175, 55, 0.7);
  letter-spacing: 0.8px;
  text-transform: uppercase;
}

/* ── Profile ─────────────────────────────────────────── */
.profile-card {
  display: flex;
  align-items: center;
  margin: 16px 16px 4px;
  padding: 12px 14px;
  background: rgba(255, 255, 255, 0.04);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.07);
}
.profile-avatar {
  background: rgba(212, 175, 55, 0.15);
  color: #d4af37;
  border-radius: 50%;
  flex-shrink: 0;
}
.profile-name {
  font-size: 13px;
  font-weight: 600;
  color: #ffffff;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 140px;
}
.role-badge {
  background: rgba(212, 175, 55, 0.18) !important;
  color: #d4af37 !important;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.5px;
  margin-top: 3px;
  padding: 2px 8px;
}

/* ── Section labels ──────────────────────────────────── */
.section-label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: rgba(212, 175, 55, 0.5);
  padding: 16px 20px 6px;
}

/* ── Nav list ────────────────────────────────────────── */
.nav-list {
  padding: 4px 10px 80px;
}

.nav-item {
  border-radius: 10px;
  margin-bottom: 2px;
  min-height: 44px;
  transition: background 0.18s ease;
  background: transparent !important;
  color: inherit !important;
}
.nav-item:hover {
  background: rgba(255, 255, 255, 0.06) !important;
}
.nav-item :deep(.q-focus-helper) {
  display: none;
}
.nav-item .nav-label {
  font-size: 13.5px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.65);
  transition: color 0.18s;
}
.nav-item .q-icon {
  color: rgba(255, 255, 255, 0.4);
  transition: color 0.18s;
}
.nav-icon-wrap {
  min-width: 36px !important;
}

/* Active state */
.nav-item--active {
  background: rgba(212, 175, 55, 0.13) !important;
  border-left: 3px solid #d4af37;
  padding-left: calc(16px - 3px) !important;
}
.nav-item--active .nav-label {
  color: #d4af37 !important;
  font-weight: 600;
}
.nav-item--active .q-icon {
  color: #d4af37 !important;
}

/* ── Footer / Logout ─────────────────────────────────── */
.sidebar-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  background: #0d1b2a;
}
.logout-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 10px 16px;
  border: 1px solid rgba(255, 100, 100, 0.25);
  border-radius: 10px;
  background: rgba(255, 80, 80, 0.06);
  color: rgba(255, 120, 120, 0.85);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.18s, color 0.18s;
  letter-spacing: 0.3px;
}
.logout-btn:hover {
  background: rgba(255, 80, 80, 0.14);
  color: #ff6b6b;
}
</style>

<style>
/* Global overrides — Quasar drawer internals */
.sidebar .q-drawer__content,
.sidebar .q-scrollarea,
.sidebar .q-scrollarea__container,
.sidebar .q-scrollarea__content,
.sidebar .q-list,
.sidebar .q-item {
  background: #0d1b2a !important;
  color: inherit !important;
}
.sidebar .q-item__section--avatar {
  min-width: 36px !important;
  padding-right: 8px !important;
}
</style>
